import { AppBox, AppText } from "../../../../commons/components";
import { IUser } from "../../../../commons/models/i-user";
import { toTitleCase } from "../../../../commons/utilities/string-utils";

interface UserAdminAssignUnassignProps {
  user: IUser;
  isAdminAssign: boolean;
}
export default function UserAdminAssignUnassign({
  user,
  isAdminAssign,
}: UserAdminAssignUnassignProps) {
  return (
    <AppBox displayBlock>
      {isAdminAssign ? (
        <AppText>
          Once you make the user <strong>“{toTitleCase(user.fullName)}”</strong>{" "}
          admin, the user will be able to access all control of the application.
        </AppText>
      ) : (
        <AppText>
          Once you remove the user{" "}
          <strong>“{toTitleCase(user.fullName)}”</strong> as admin, the user's
          access in the application will be limited.
        </AppText>
      )}
    </AppBox>
  );
}
